var config = {
  apiEndpoint: "https://fatabyyano.net/wp-json",
  pageCovid19Tags: [3970],
  postsPerFetch: 20,
  timelineMinDate: "1/1/2017",
  addThisPubId: "ra-5f3d9e7a7b427c14",
};

export default config;
